import React from 'react';
import createReactClass from 'create-react-class';
import _ from 'underscore';
import IntegrationActionCreator from 'action_creators/integration';
import TourPageAbout from 'views/shared/tours/page/about';
import ContactGuide from 'views/plugins/tours/page/contact_guide';
import Title from 'views/shared/tours/page/about/title';
import AboutPropTypesMixin from 'views/shared/tours/page/about/prop_types_mixin';
import ComputerIcn from 'views/ui/icons/computer';
import styled from '@emotion/styled';
import { brandNeutralColors } from 'ui_system/compass';
import { t, loadLocales } from 'services/translation';
import './index.scss';

const OnlineLabel = styled.span`
  color: ${brandNeutralColors.text.secondary};
  margin-left: 0.5rem;
`;

export const AboutWrapper = createReactClass({
  displayName: 'TourPage-About-Wrapper-Plugins',
  mixins: [AboutPropTypesMixin],

  _viewProps() {
    const extraProps = {
      locationAndContactNode: this._content(),
      title: this._title(),
    };

    return _.extend({}, this.props, extraProps);
  },

  scrollToMap() {
    if (window.top !== window.self) {
      IntegrationActionCreator.scrollToSelector('.TourPage-Map');
    }
  },

  locationComponent() {
    const languageParam = new URL(window.location.href).searchParams.get(
      'lang'
    );
    loadLocales(languageParam || 'en-US');
    const { multiple_locations: multipleLocations, online, place } = this.props;
    if (!(multipleLocations || online)) {
      return (
        <div
          className="TourPage-About-location"
          data-testid="tour-page-about-location"
        >
          <a
            href={`https://www.google.com/maps/search/${place}`}
            className="brand-color"
            target="_blank"
          >
            <i
              className="icon anyfont af-pin"
              aria-hidden="true"
              alt="location pin"
            />
            {place}
          </a>
        </div>
      );
    }
    if (online) {
      return (
        <div className="TourPage-About-location">
          <ComputerIcn fill={brandNeutralColors.text.icon} width="1.3em" />
          <OnlineLabel>{t('ONLINE')}</OnlineLabel>
        </div>
      );
    }
    return null;
  },

  _content() {
    return (
      <div>
        {this.locationComponent()}
        <hr className="TourPage-About-hr" />
        {this.renderContactGuideWidget()}
      </div>
    );
  },

  _title() {
    const { tour_name: tourName } = this.props;
    return <Title name={tourName} />;
  },

  renderContactGuideWidget() {
    const {
      guide_id: guideId,
      guide_name: guideName,
      guide_picture_url: guidePictureUrl,
      hide_contact_button: hideContactButton,
      id,
      is_company: isCompany,
      tour_name: tourName,
    } = this.props;
    if (!hideContactButton) {
      return (
        <div className="TourPage-About-contact">
          <ContactGuide
            guideId={guideId}
            tourId={id}
            guideName={guideName}
            guidePictureUrl={guidePictureUrl}
            isCompany={isCompany}
            theme="anyguide"
            tourName={tourName}
          />
        </div>
      );
    }
    return null;
  },

  render() {
    return <TourPageAbout {...this._viewProps()} />;
  },
});
